import { render, staticRenderFns } from "./ComparisonOfClassHistory.vue?vue&type=template&id=ee59add2&scoped=true&"
import script from "./ComparisonOfClassHistory.vue?vue&type=script&lang=js&"
export * from "./ComparisonOfClassHistory.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonOfClassHistory.vue?vue&type=style&index=0&id=ee59add2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee59add2",
  null
  
)

export default component.exports